<template>
  <div class="kabaddi-schedule">
    <div>
      <h2>Schedule</h2>
      <loading-state :state="state"></loading-state>
      <kabaddi-season-menu :seasonKey="seasonKey"></kabaddi-season-menu>
      <div v-if="schedule != null">
        <div>
          <ul class="fullwidth-menu">
            <li
              class="link"
              v-for="day in schedule.days"
              v-if="day.matches.length"
              :class="{active: activeDay && activeDay.isSame(day.day)}"
              @click="activeDay = day.day"
              :key="day.$index">
              {{day.day | momentFormat('ddd Do')}}
            </li>
          </ul>
        </div>

        <section
        v-for="day in schedule.days"
        v-if="day.matches.length && activeDay && activeDay.isSame(day.day)"
        :key="day.$index">
          <h3>{{day.day | momentFormat('dddd, MMMM Do')}}</h3>
          <div class="sub-content">
            <div class="item compact link" v-for="match in day.matches" :key="match.key">
              <kabaddi-match-mini :match="match" :showDate="false"></kabaddi-match-mini>
            </div>
          </div>
        </section>
        <section v-if="activeDay === null">
          <div>Select a date to view schedule</div>
        </section>
      </div>

    </div>
  </div>
</template>

<script>
import { KabaddiSeason } from '@/models/kabaddi/season'
import { DataState, AppState } from '@/state'

export default {
  data () {
    return {
      activeDay: null,
      seasonKey: this.$route.params.key,
      schedule: null,
      state: DataState.newLoading()
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.key !== from.params.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned () {
      this.seasonKey = this.$route.params.key
      const newTitle = 'loading...'
      AppState.updateActivePage(`kabadd_season_${this.seasonKey}_schedule`)
      AppState.updateTitles(newTitle, newTitle)

      KabaddiSeason.fetchSchedule(this.seasonKey).then(months => {
        const newTitle = `Schedule`
        AppState.updateTitles(newTitle, newTitle)
        months.forEach((schedule) => {
          if (this.schedule === null || schedule.isCurrentMonth) {
            this.schedule = schedule
          }
        })
        this.identifyActiveDay()
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },
    prepareToReopen () {
      this.schedule = null
    },
    refreshView () {

    },
    identifyActiveDay () {
      const today = new Date()
      let lastDay = null
      for (let i = 0; i < this.schedule.days.length; i++) {
        if (this.schedule.days[i].matches.length > 0) {
          const day = this.schedule.days[i].day
          lastDay = day
          const couldBeActive = day.isSame(today, 'day') || day.isAfter(today, 'day')
          if (this.activeDay === null && day && couldBeActive) {
            this.activeDay = day
            break
          }
        }
      }

      if (this.activeDay === null) {
        this.activeDay = lastDay
      }
    }
  }
}
</script>
